import { type FC } from "react";

import { faCheck } from "@fortawesome/pro-duotone-svg-icons/faCheck";
import { faCopy } from "@fortawesome/pro-duotone-svg-icons/faCopy";
import { faFileDownload } from "@fortawesome/pro-duotone-svg-icons/faFileDownload";
import { faFileWord } from "@fortawesome/pro-duotone-svg-icons/faFileWord";
import { faInfoSquare } from "@fortawesome/pro-duotone-svg-icons/faInfoSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { type TranscriptDocumentFragment } from "@app_schema";

import { useClipboard } from "@application/hooks/use_clipboard";

import { track } from "@application/utilities/track";

import { Button } from "@styled/button";
import { ButtonAnchor } from "@styled/button_anchor";
import { Menu } from "@styled/menu";
import { MenuButtonEllipsis } from "@styled/menu_button_ellipsis";
import { MenuItemAnchor } from "@styled/menu_item_anchor";
import { MenuItemLink } from "@styled/menu_item_link";
import { MenuItems } from "@styled/menu_items";
import { PillGroup } from "@styled/pill_group";

// Copy hands over the view on screen; Download Word is the cleaned
// transcript. The uploaded file and its page sit behind •••.
export const TranscriptActions: FC<{
  projectId: string;
  document: Pick<TranscriptDocumentFragment, "id" | "file" | "transcriptDocx">;
  text: string;
}> = ({ projectId, document, text }) => {
  const { copied, copy } = useClipboard(text);

  return (
    <PillGroup>
      <Button
        type="button"
        color="white"
        size="sm"
        disabled={!text}
        onClick={() => void copy()}
      >
        <FontAwesomeIcon icon={copied ? faCheck : faCopy} />{" "}
        {copied ? "Copied" : "Copy"}
      </Button>
      {document.transcriptDocx && (
        <ButtonAnchor
          color="white"
          size="sm"
          href={document.transcriptDocx.url}
          download
          onClick={() =>
            track("document_downloaded", {
              project_id: projectId,
              document_id: document.id,
              kind: "transcript",
            })
          }
        >
          <FontAwesomeIcon icon={faFileWord} /> Download Word
        </ButtonAnchor>
      )}
      <Menu>
        <MenuButtonEllipsis />
        <MenuItems anchor="bottom end">
          <MenuItemAnchor href={document.file.url} download>
            <FontAwesomeIcon icon={faFileDownload} /> Original file
          </MenuItemAnchor>
          <MenuItemLink
            to={`/dashboard/projects/${projectId}/documents/${document.id}`}
          >
            <FontAwesomeIcon icon={faInfoSquare} /> File details
          </MenuItemLink>
        </MenuItems>
      </Menu>
    </PillGroup>
  );
};
